import * as React from 'react';
import { Box, Button, Checkbox, CssVarsProvider, FormControl, FormLabel, Grid, Input, Link, Sheet, Stack, Table, Typography } from "@mui/joy"
import { useDispatch, useSelector } from "react-redux"
import { defineAttr, setEncryptKey, triggerCarregaDB } from "./NotetakerSlice"
import { formatDateJavaComHoras, isNotNull } from '../helper/functions'
import { Link as RouterLink } from "react-router-dom"

function Notetaker() {

    var store = useSelector((state) => state.notetaker)

    if (store.dbCarregadoComSucesso != true) {
        return <RequireEncryptKey />
    }

    return <NoteBrowser />
}


function NoteBrowser() {

    var dispatch = useDispatch()
    var data = useSelector((state) => state.notetaker.data)
    var busca = useSelector((state) => state.notetaker.busca)
    var tags = useSelector((state) => state.notetaker.tags)

    var filterTag = (e) => {

        // Sem filtro selecionado
        if (tags.length == 0) return true

        // Sem tag
        if (tags.includes("SEM TAG") && e.tags.length == 0) return true

        // Remove as concluidas
        if (tags.includes("NAO CONCLUIDA")) {
            if (e.tags.includes("CONCLUIDA")) return false
            if (tags.length == 1) return true
        }

        // Tag matchting
        var found = false
        tags.forEach(x => {
            if (e.tags.includes(x)) found = true
        })
        return found
    }

    var addTag = (e) => {

        var novaTags = [...tags]

        if (e.target.value != "TODAS") {
            var index = novaTags.findIndex(x => x == e.target.value)
            if (index == -1) {
                novaTags.push(e.target.value)
            } else {
                novaTags.splice(index, 1)
            }

        } else {
            novaTags = []
        }

        dispatch(defineAttr({
            campo: "tags",
            value: novaTags
        }))
    }

    var remove = (id) => {}

    var TagCheckbox = (props) => {
        return <Checkbox name={props.label} value={props.tag} label={props.label} onClick={addTag} checked={props.tag == "TODAS" ? tags.length == 0 : tags.includes(props.tag)} />
    }

    return <Grid container>
        <Grid style={{ padding: "10px" }} xs={12}>
            <Stack direction={"row"} spacing={1}>
                <Input value={busca}
                    style={{ width: "100%" }}
                    placeholder='Buscar...'
                    onChange={(e) => {
                        dispatch(defineAttr({
                            campo: "busca",
                            value: e.target.value
                        }))
                    }}></Input>
                <RouterLink to="/notetaker/editor">
                    <Button>+</Button>
                </RouterLink>
            </Stack>
        </Grid>
        <Grid style={{ padding: "10px" }} xs={12}>
            <Stack direction={"row"} spacing={2}>
                <TagCheckbox label="Todas" tag="TODAS" />
                <TagCheckbox label="Não concluída" tag="NAO CONCLUIDA" />
                <TagCheckbox label="Concluída" tag="CONCLUIDA" />
                <TagCheckbox label="Sem tag" tag="SEM TAG" />
                <TagCheckbox label="Importante" tag="IMPORTANTE" />
                <TagCheckbox label="Prioridade" tag="PRIORIDADE" />
                <TagCheckbox label="Revisar" tag="REVISAR" />
            </Stack>
        </Grid>
        <Grid style={{ padding: "10px" }}>
            <Box>
                <Table size="small" aria-label="striped table" stripe={"odd"}>
                    <thead>
                        <tr>
                            <th style={{ width: "15%", textAlign: "left" }}>Criação</th>
                            <th style={{ textAlign: "left" }}>Notas</th>
                            <th style={{ width: "3%", textAlign: "center" }}>X</th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* {console.log("123", typeof(data))} */}
                        {
                        
                            
                            data
                            .filter(filterTag)
                            .filter(e => {
                                if (isNotNull(busca) && busca.length > 0) {
                                    return e.titulo.toUpperCase().includes(busca.toUpperCase())
                                }
                                return true;
                            })
                            .map((row) => {
                                return <tr key={row.id} className='nova_linha'>
                                    <td style={{ padding: "2px 0px" }}>
                                        {formatDateJavaComHoras(row.dataCriacao)}
                                    </td>
                                    <td style={{ padding: "2px 0px" }}>
                                        {/* <Link onClick={() => openNota(row.id)}>{row.titulo}</Link> */}
                                        <RouterLink to={"/notetaker/editor/" + row.id}>{row.titulo}</RouterLink>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Link onClick={() => remove(row.id)} className='link_remove' style={{ color: "#C20000", display: "none" }}>[ x ]</Link>
                                    </td>
                                </tr>
                            })}
                    </tbody>
                </Table>
            </Box>
        </Grid>
    </Grid>

}

function RequireEncryptKey() {
    var dispatch = useDispatch()
    var state = useSelector((state) => state.notetaker)
    var encryptKey = state.encryptKey ?? ""
    var processando = state.processando

    var update = (e) => dispatch(setEncryptKey(e.target.value))
    var processar = () => dispatch(triggerCarregaDB())

    React.useEffect(() => {
        update({
            target: {
                value: "oi110789"
            }
        })
        processar()
    }, []);

    return <CssVarsProvider>
        <main>
            {/* <ModeToggle /> */}
            <Sheet
                sx={{
                    width: 300,
                    mx: 'auto', // margin left & right
                    my: 4, // margin top & botom
                    py: 3, // padding top & bottom
                    px: 2, // padding left & right
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    borderRadius: 'sm',
                    background: "#fff",
                    boxShadow: 'md',
                }}
                variant="outlined"
            >
                <Stack spacing={2}>
                    <Typography level="h4" component="h1" style={{ textAlign: "center" }}>
                        <b>Forneça a encrypt_key</b>
                    </Typography>
                    <div style={{ textAlign: "center" }}>
                        <div>
                            <Typography level="body2" style={{ color: "#c20000" }}>{state.statusText}</Typography>
                        </div>
                    </div>
                    <Input
                        name="password"
                        type="text"
                        value={encryptKey}
                        disabled={processando}
                        onChange={update}
                        placeholder="digite sua senha..."
                        label="Password"
                    />
                    <Button sx={{ mt: 1 /* margin top */ }} onClick={() => processar()}
                        disabled={processando}>Acessar</Button>

                </Stack>
            </Sheet>
        </main>
    </CssVarsProvider>
}

export default Notetaker